export const Avatar = ({name = '', surname = '', className = ''}) => (
  <div className={['header-avatar', className].join(' ')}>
    <span className="header-avatar-name">{name?.charAt(0)}</span>
    {surname && <span className="header-avatar-name">{surname?.charAt(0)}</span>}
  </div>
)
